module.exports = __webpack_public_path__ + "static/media/printing-services-img17.8e3cfb9a.jpg";